import React from "react";
import "./style.css";

const SaveJamesSection = () => {
  const steps = [
    {
      title: "CREATE WALLET",
      description:
        "download phantom or your wallet of choice from the app store or google play for free.",
      buttonText: "Get Phantom",
      href: "https://phantom.com/en-GB",
    },
    {
      title: "GET SOME SOL",
      description:
        "have sol in your wallet to switch to $savejames. if you don't have any sol, you can buy directly on phantom, transfer from another wallet, or buy on different centralized or decentralized exchange and send it to your wallet.",
      buttonText: "Buy SOL",
      href: "https://phantom.com/en-GB",
    },
    {
      title: "GO TO JUPITER",
      description:
        "connect to jupiter on chrome, paste the $savejames contract, select trade, and confirm the prompts when your wallet is ready. your trade is done.",
      buttonText: "Buy SaveJames",
      href: "https://jup.ag/swap/S3v7783sJ2kidHdzZMG",
    },
    {
      title: "Educate Others",
      description:
        "help us spread awareness by educating others about the resources, vision, and importance of our campaign.",
      buttonText: "LEARN MORE",
      href: "https://x.com/JeffYoungerShow",
    },
  ];

  return (
    <div className="save-james-section">
      <h2 className="section-title">How to Support</h2>
      <div className="cards-container">
        {steps.map((step, index) => (
          <div key={index} className="info-card">
            <h3 className="info-card-title">{step.title}</h3>
            <p className="info-card-description">{step.description}</p>
            <a
              className="info-card-button"
              href={step?.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              {step.buttonText}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SaveJamesSection;
